import { Task } from "@/api/mutation/useTaskCreateMutation";

export function generateUniqueTaskName(tasks: Task[], projectName: string): string {
  // Regular expression to match task names and extract the number
  const taskNamePattern = new RegExp(`^${projectName}_new-task_(\\d+)$`);
  let maxNumber = 0;

  // Iterate over tasks to find the highest existing number for the given project
  tasks.forEach((task) => {
    const match = task.taskName.match(taskNamePattern);
    if (match && match[1]) {
      const taskNumber = parseInt(match[1], 10);
      if (taskNumber > maxNumber) {
        maxNumber = taskNumber;
      }
    }
  });

  // Increment the highest number to get the new task number
  const newTaskNumber = maxNumber + 1;
  const newTaskName = `${projectName}_new-task_${newTaskNumber}`;

  // Ensure the new task name is unique (should not be necessary with above logic, but added for safety)
  if (tasks.some((task) => task.taskName === newTaskName)) {
    return generateUniqueTaskName(tasks, projectName); // Recursively call to find a truly unique name
  }

  return newTaskName;
}


